import { createAsyncThunk } from "@reduxjs/toolkit";
import { getWorkplaces } from "../../../api/auth/authServices";

export const getWorkplacesThunk = createAsyncThunk(
  "auth/getWorkplaces",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getWorkplaces();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);